import React, { useState, useMemo, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { styles } from '../../styles'
import { Box, Input, withStyles, Button } from '@material-ui/core'
import { authorization } from '../../../../../../../../../Module/Auth/Auth'
import { optionsStages } from '../../../../options'
import Sidebar from '../../../Sidebar'
import Select from '../../../Select'
import { useEditSequenceContext } from '../context/EditSequenceContext'
import StartSequence from './components/StartSequence'
import Schedule from './components/Schedule'
import Trigger from './components/Trigger'
import EmailTemplate from './components/EmailTemplate'
import { SmsAndNotificationTemplate } from './components/SmsAndNotificationTemplate'
import ControlButtonsSection from '../../../ControlButtonsSection'
import { handleConfirmationDialog } from '../../../../utils'
import { CommunicationsModal } from './components/CommunicationsModal'
import { STEPS } from '../../../../constants'

const EditSequenceLayout = ({
  classes,
  cityId,
  cityEmail,
  isOnsiteTrainingEnabled,
  cityTimezone,
  handleBack,
  onSubmit,
  disableSubmit,
  setConfirmDialogData,
}) => {
  const location = useLocation()
  const {
    createEmptySchedule,
    createEmptyTrigger,
    deleteSchedule,
    deleteTrigger,
    updateSequence,
    updateStage,
    saveOrUpdateTemplate,
    saveOrUpdateNotificationAndSms,
    deleteAction,
    setErrors,
    editSequenceContextState,
  } = useEditSequenceContext()
  const { sequence, stage, errors: contextErrors } = editSequenceContextState
  const user = useMemo(() => authorization.getUser(), [])
  const [error, setError] = useState('')
  const [openedDrawer, setOpenedDrawer] = useState(false)
  const [commId, setCommId] = useState(null)
  const [commType, setCommType] = useState(null)
  const [actionId, setActionId] = useState(null)
  const [openModal, setOpenModal] = useState(false)

  useEffect(() => {
    if (error) {
      setErrors({ type: 'sequenceName', error })
    } else if (contextErrors.sequenceName) {
      setErrors({ type: 'sequenceName', error: '' })
    }
  }, [error])

  const closeDrawer = () => {
    if (openedDrawer) {
      setOpenedDrawer(false)
    }
  }

  const handleSequenceNameChange = e => {
    updateSequence({ name: e.target.value })
    if (!e.target.value) {
      setError('The sequence should have a name')
    } else {
      setError('')
    }
  }

  const controlModal = ({ eId, aId, open, cType }) => {
    setCommId(eId)
    setActionId(aId)
    setOpenModal(open)
    setCommType(cType)
  }

  const openStep = step => {
    setOpenedDrawer(false)
    if (step == 'trigger') {
      createEmptyTrigger()
    }
    if (step == STEPS.SCHEDULE) {
      createEmptySchedule()
    }
    if (step == 'mail') {
      controlModal({ eId: null, aId: null, open: true, cType: 'email' })
    }
    if (step == 'sms') {
      controlModal({ eId: null, aId: null, open: true, cType: 'sms' })
    }
    if (step == 'notification') {
      controlModal({ eId: null, aId: null, open: true, cType: 'notification' })
    }
  }

  const onTemplateSubmit = args => {
    if (commType === 'email') {
      saveOrUpdateTemplate({ ...args, emailId: commId })
    }
    if (commType === 'notification' || commType === 'sms') {
      saveOrUpdateNotificationAndSms({ ...args, commId, commType })
    }
    controlModal({ open: false, eId: null, aId: null })
  }

  const handleScheduleDelete = async scheduleId => {
    if (
      sequence.Action.length > 0 &&
      sequence.DateSequenceTemplate.length == 1
    ) {
      handleConfirmationDialog({
        title: `There needs to be at least one Schedule or Trigger when there are Communications. \n Please delete communications first.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
    } else if (scheduleId) {
      handleConfirmationDialog({
        title: `Are you sure you want to delete this schedule?`,
        setConfirmDialogData,
        hasOptions: true,
        rightButtonLable: 'CONFIRM',
        leftButtonLable: 'CANCEL',
        onConfirm: () => deleteSchedule(scheduleId),
      })
    }
  }

  const handleTriggerDelete = async triggerId => {
    if (sequence.Action.length > 0 && sequence.Trigger.length == 1) {
      handleConfirmationDialog({
        title: `There needs to be at least one Trigger when there are Emails. \n Please delete emails first.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
    } else if (triggerId) {
      handleConfirmationDialog({
        title: `Are you sure you want to delete this trigger?`,
        setConfirmDialogData,
        hasOptions: true,
        rightButtonLable: 'CONFIRM',
        leftButtonLable: 'CANCEL',
        onConfirm: () => deleteTrigger(triggerId),
      })
    }
  }

  const handleActionDelete = (id, commType) => {
    if (id) {
      handleConfirmationDialog({
        title: `Are you sure you want to delete this ${commType}?`,
        setConfirmDialogData,
        hasOptions: true,
        rightButtonLable: 'CONFIRM',
        leftButtonLable: 'CANCEL',
        onConfirm: () => deleteAction(id),
      })
    }
  }

  return (
    <div className={classes.tableWrapper}>
      {/* TODO (Ricardo): Remove isArray validation when data integration is made */}
      <Sidebar
        opened={openedDrawer}
        onSelectStep={openStep}
        scheduleCount={
          sequence.DateSequenceTemplate
            ? sequence.DateSequenceTemplate.reduce(
                (a, c) => (c.id ? ++a : a),
                0,
              )
            : 0
        }
        triggerCount={sequence.Trigger.reduce((a, c) => (c.id ? ++a : a), 0)}
        memoryTriggerCount={sequence.Trigger.length}
      />
      <Box onClick={closeDrawer}>
        <CommunicationsModal
          openModal={openModal}
          controlModal={controlModal}
          cityId={cityId}
          cityEmail={cityEmail}
          userEmail={user.email}
          onTemplateSubmit={onTemplateSubmit}
          commId={commId}
          actionId={actionId}
          commType={commType}
        />
        <ControlButtonsSection onBack={handleBack} />
        <div className={classes.inputWrap}>
          <Box
            style={{
              fontSize: '18px',
              paddingRight: '10px',
              paddingBottom: '30px',
            }}
          >
            Name
          </Box>
          <Input
            style={{
              marginLeft: '3px',
              height: '28px',
              fontSize: '16px',
              width: 315,
            }}
            value={sequence.name}
            onChange={handleSequenceNameChange}
            variant="filled"
          />
          <Select
            label="Stage:"
            value={stage}
            className={classes.stageSelect}
            options={optionsStages.filter(option => {
              if (!isOnsiteTrainingEnabled) {
                return ![
                  'all',
                  'videoOnboarding',
                  'quiz',
                  'onSiteTraining',
                ].includes(option.value)
              }
              return !['all', 'videoOnboarding', 'quiz'].includes(option.value)
            })}
            onChange={updateStage}
          />
          <Button
            variant="outlined"
            className={classes.saveButton}
            onClick={onSubmit}
            disabled={disableSubmit}
          >
            Save
          </Button>
        </div>
        <p className={classes.error}>{error}</p>
        {sequence.DateSequenceTemplate.length === 0 &&
        sequence.Trigger.length == 0 &&
        sequence.Action.length == 0 ? (
          <div>
            <StartSequence
              handleDrawerToggle={setOpenedDrawer}
              isNamed={sequence.name.length > 0}
            />
          </div>
        ) : null}

        {sequence.Trigger.map((trigger, index) => (
          <Trigger
            id={trigger.id}
            index={index}
            trigger={trigger}
            sequence={sequence}
            onDelete={handleTriggerDelete}
            handleDrawerToggle={setOpenedDrawer}
            isAnyElementBelow={
              sequence.Action ? sequence.Action.length > 0 : false
            }
          />
        ))}

        {(sequence.DateSequenceTemplate || []).map((schedule, index) => (
          <Schedule
            id={schedule.id}
            index={index}
            schedule={schedule}
            handleDrawerToggle={setOpenedDrawer}
            isAnyElementBelow={
              sequence.Action ? sequence.Action.length > 0 : false
            }
            onDelete={handleScheduleDelete}
            cityTimezone={cityTimezone}
          />
        ))}

        {sequence.Action.map((action, index, actions) => {
          if (!!action.template && action.actionType.name === 'EMAIL') {
            return (
              <EmailTemplate
                actionId={action.id}
                action={action}
                index={index}
                emailId={action.template.id}
                email={action.template}
                onDelete={handleActionDelete}
                controlModal={controlModal}
                handleDrawerToggle={setOpenedDrawer}
                totalActions={actions.length}
                seqStatus={
                  location.state ? location.state.seqStatus : undefined
                }
              />
            )
          } else if (
            !!action.template &&
            (action.actionType.name === 'NOTIFICATION' ||
              action.actionType.name === 'SMS')
          ) {
            return (
              <SmsAndNotificationTemplate
                commId={action.template.id}
                actionId={action.id}
                template={action.template}
                action={action}
                onDelete={handleActionDelete}
                controlModal={controlModal}
                handleDrawerToggle={setOpenedDrawer}
                totalActions={actions.length}
                index={index}
                commType={action.actionType.name.toLowerCase()}
                seqStatus={
                  location.state ? location.state.seqStatus : undefined
                }
              />
            )
          }
          return null
        })}
      </Box>
    </div>
  )
}

export default withStyles(styles)(EditSequenceLayout)
